import { green } from '@ant-design/colors';
import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Row, Typography } from 'antd';

import { InlineStylesModel } from 'models/InlineStylesModel';
import { SparingRequestLineItemPayload } from 'models/SparingRequests';
import React from 'react';
const { Text, Title } = Typography;

interface Props {
  product: SparingRequestLineItemPayload;
  availableQuantity: number;
  isLoading: boolean;
  children: JSX.Element;
}

const styles: InlineStylesModel = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    lineHeight: 1
  },
  cardBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  cardTitle: {
    width: '250px',
    maxWidth: '100%'
  },
  productInfo: { display: 'flex', flexDirection: 'column', textAlign: 'end' },
  productDescription: {
    flex: 1,
    marginBottom: 24
  }
};

export const ProductCartCard: React.FC<Props> = ({ product, children, availableQuantity, isLoading }) => {
  /* ******************** Hooks ******************** */

  // Provide fallback values for optional fields that might be undefined
  const displayName = product.productName || product.productNumber || 'Unknown Product';
  const displayManufacturer = product.manufacturer || product.productNumber || 'Unknown Manufacturer';
  const displayCategory = product.category || product.productNumber || 'Unknown Category';
  const displayDescription = product.productDescription || 'No description available';

  const cardTitleJSX = (
    <div style={styles.cardTitle}>
      <Title style={{ margin: 0 }} level={4}>
        {displayName}
      </Title>
      <Text style={{ fontWeight: 'normal', fontSize: '12px' }} type="secondary">
        {displayManufacturer}
      </Text>
    </div>
  );

  /* ******************** Render ******************** */
  return (
    <Card className="narrow-cart-card" style={styles.container} title={cardTitleJSX} bodyStyle={styles.cardBody}>
      <Row gutter={[0, 8]}>
        <Col xs={24} lg={16}>
          <Text style={styles.productDescription}>{displayDescription}</Text>
        </Col>
        <Col xs={12} lg={4}>
          <div style={styles.productInfo}>
            <Text type="success">Available: {isLoading ? <LoadingOutlined style={{ color: green.primary }} /> : availableQuantity}</Text>
          </div>
        </Col>
        <Col xs={12} lg={4} style={{ textAlign: 'right' }}>
          {children}
        </Col>
      </Row>
    </Card>
  );
};
